var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import BookPage from './BookPage';
import { createBookNotification, deleteBookNotification, getBook, getExternalPrices, getTopTags, listBookNotifications, } from '../utils/api/bookApi';
import { captureEvent } from '../utils/gaUtil';
import { mapBinding } from '../utils/book/bindingHelper';
import useBrowserAuthMe from '../hooks/useBrowserAuthMe';
import './BookDetailsPage.less';
var ACTIVE_EXTERNAL_BOOKSTORES = ['adlibris', 'norli'];
var formatAuthors = function (authors) { return authors.join(', '); };
var formatPublished = function (book) {
    var binding = book.binding && book.binding !== 'Other' ? mapBinding(book.binding) : null;
    if (book.publishedYear) {
        return [
            book.publishedYear,
            book.edition ? book.edition + ". utgave" : null,
            binding,
        ].filter(Boolean).join(', ');
    }
    return binding;
};
var formatExternalPrice = function (price) { return (price === null || price === undefined ? 'ingen pris' : price + ",-"); };
var findNotificationForBook = function (notifications, isbn) { return (notifications.find(function (notification) { return Number(notification.isbn) === Number(isbn); }) || null); };
var getLoginPath = function () { return "/logg_inn?redirect=" + encodeURIComponent(window.location.pathname + window.location.search); };
var BookMetadata = function (_a) {
    var book = _a.book, tags = _a.tags;
    var published = formatPublished(book);
    return React.createElement("div", null,
        React.createElement("section", { className: "object book detailed book-details-page__book", id: "book-isbn-" + book.isbn },
            React.createElement("div", { className: "book-cover" }, book.imageUrl && React.createElement("img", { src: book.imageUrl, alt: book.title })),
            React.createElement("h1", null, book.title),
            React.createElement("dl", null,
                book.authors.length > 0 && React.createElement(React.Fragment, null,
                    React.createElement("dt", null, "Av"),
                    React.createElement("dd", null, formatAuthors(book.authors))),
                book.publisher && React.createElement(React.Fragment, null,
                    React.createElement("dt", null, "Forlag"),
                    React.createElement("dd", null, book.publisher)),
                React.createElement("dt", null, "ISBN"),
                React.createElement("dd", null, book.isbn),
                published && React.createElement(React.Fragment, null,
                    React.createElement("dt", null, book.publishedYear ? 'Utgitt' : 'Innbinding'),
                    React.createElement("dd", null, published)))),
        React.createElement("p", null,
            "Ikke riktig utgave? Pr\u00F8v \u00E5",
            ' ',
            React.createElement("a", { href: "/sok?query=" + encodeURIComponent(book.title) }, "s\u00F8ke etter flere utgaver"),
            "."),
        tags.length > 0 && React.createElement("div", { className: "tags" }, tags.map(function (tag) { return (React.createElement("a", { key: tag, href: "/sok?query=" + encodeURIComponent(tag) }, tag)); })));
};
var ExternalPrices = function (_a) {
    var isbn = _a.isbn, prices = _a.prices;
    return (React.createElement("section", null,
        React.createElement("h2", null, "Kj\u00F8p ny"),
        React.createElement("nav", { className: "grid external-price" }, ACTIVE_EXTERNAL_BOOKSTORES.map(function (bookstore) {
            var price = prices[bookstore] || { bookstore: bookstore, price: null, url: null };
            var content = React.createElement(React.Fragment, null,
                React.createElement("img", { src: "/static/img/" + bookstore + ".png", alt: bookstore }),
                React.createElement("span", { id: bookstore + "-price", className: "books_price" }, formatExternalPrice(price.price)),
                React.createElement("i", { className: "arrow" }));
            if (!price.url) {
                return React.createElement("span", { key: bookstore, className: "object " + bookstore }, content);
            }
            return React.createElement("a", { key: bookstore, className: "object " + bookstore, id: bookstore, href: price.url, onClick: function () { return captureEvent('affiliate', bookstore, String(isbn)); }, rel: "nofollow", target: "_blank" }, content);
        }))));
};
var BookNotification = function (_a) {
    var book = _a.book, user = _a.user, isAuthLoading = _a.isAuthLoading;
    var _b = React.useState(null), notification = _b[0], setNotification = _b[1];
    var _c = React.useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = React.useState(false), isSaving = _d[0], setIsSaving = _d[1];
    var _e = React.useState(null), error = _e[0], setError = _e[1];
    React.useEffect(function () {
        var isMounted = true;
        setNotification(null);
        setError(null);
        if (!user) {
            setIsLoading(false);
            return function () {
                isMounted = false;
            };
        }
        setIsLoading(true);
        listBookNotifications()
            .then(function (notifications) {
            if (isMounted) {
                setNotification(findNotificationForBook(notifications, book.isbn));
            }
        })
            .catch(function () {
            if (isMounted) {
                setError('Kunne ikke hente bokvarslingene dine.');
            }
        })
            .finally(function () {
            if (isMounted) {
                setIsLoading(false);
            }
        });
        return function () {
            isMounted = false;
        };
    }, [book.isbn, user]);
    var createNotification = function () {
        setError(null);
        setIsSaving(true);
        createBookNotification(book.isbn)
            .then(function (nextNotification) { return setNotification(nextNotification); })
            .catch(function () { return setError('Kunne ikke opprette bokvarsling. Prøv igjen.'); })
            .finally(function () { return setIsSaving(false); });
    };
    var deleteNotification = function () {
        if (!notification) {
            return;
        }
        setError(null);
        setIsSaving(true);
        deleteBookNotification(notification.bookId)
            .then(function () { return setNotification(null); })
            .catch(function () { return setError('Kunne ikke fjerne bokvarsling. Prøv igjen.'); })
            .finally(function () { return setIsSaving(false); });
    };
    return React.createElement("section", null,
        React.createElement("h2", null, "Bokvarsling"),
        error && React.createElement("p", { role: "alert", className: "error" }, error),
        isAuthLoading && React.createElement("p", null, "Laster innloggingsstatus..."),
        !isAuthLoading && !user && React.createElement(React.Fragment, null,
            React.createElement("a", { href: getLoginPath(), className: "button notification" }, "Opprett bokvarsling"),
            React.createElement("p", null, "Logg inn for \u00E5 bli varslet n\u00E5r noen legger ut denne boken for salg.")),
        !isAuthLoading && user && notification && React.createElement(React.Fragment, null,
            React.createElement("button", { type: "button", className: "button notification unsubscribe", disabled: isSaving, onClick: deleteNotification }, isSaving ? 'Fjerner...' : 'Fjern bokvarsling'),
            React.createElement("p", null, "Du har allerede opprettet bokvarsling p\u00E5 denne boken og vil automatisk bli varslet dersom noen legger den ut for salg.")),
        !isAuthLoading && user && !notification && React.createElement(React.Fragment, null,
            React.createElement("button", { type: "button", className: "button notification", disabled: isLoading || isSaving, onClick: createNotification }, isSaving ? 'Oppretter...' : 'Opprett bokvarsling'),
            React.createElement("p", null, "Dersom du trykker p\u00E5 \"Opprett bokvarsling\" vil du automatisk bli varslet n\u00E5r noen legger ut denne boken for salg.")));
};
var BookDetailsPage = function (_a) {
    var isbn = _a.isbn;
    var _b = useBrowserAuthMe(), authError = _b.error, isAuthLoading = _b.isLoading, user = _b.user;
    var _c = React.useState(null), book = _c[0], setBook = _c[1];
    var _d = React.useState([]), tags = _d[0], setTags = _d[1];
    var _e = React.useState({}), externalPrices = _e[0], setExternalPrices = _e[1];
    var _f = React.useState(true), isLoading = _f[0], setIsLoading = _f[1];
    var _g = React.useState(false), isMissing = _g[0], setIsMissing = _g[1];
    var _h = React.useState(null), error = _h[0], setError = _h[1];
    React.useEffect(function () {
        var isMounted = true;
        setBook(null);
        setTags([]);
        setExternalPrices({});
        setIsMissing(false);
        setError(null);
        setIsLoading(true);
        getBook(isbn)
            .then(function (nextBook) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, nextTags, nextExternalPrices;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!nextBook) {
                            if (isMounted) {
                                setIsMissing(true);
                            }
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Promise.all([
                                getTopTags(nextBook.isbn).catch(function () { return []; }),
                                getExternalPrices(nextBook.isbn).catch(function () { return ({}); }),
                            ])];
                    case 1:
                        _a = _b.sent(), nextTags = _a[0], nextExternalPrices = _a[1];
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setBook(nextBook);
                        setTags(nextTags);
                        setExternalPrices(nextExternalPrices || {});
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(function () {
            if (isMounted) {
                setError('Kunne ikke hente boken. Prøv igjen om litt.');
            }
        })
            .finally(function () {
            if (isMounted) {
                setIsLoading(false);
            }
        });
        return function () {
            isMounted = false;
        };
    }, [isbn]);
    if (isLoading) {
        return React.createElement("div", { className: "main-content book-details-page__status" },
            React.createElement("h1", null, "Laster bok"));
    }
    if (error) {
        return React.createElement("div", { className: "main-content book-details-page__status", role: "alert" },
            React.createElement("h1", null, "Kunne ikke hente boken"),
            React.createElement("p", null, error));
    }
    if (isMissing || !book) {
        return React.createElement("div", { className: "main-content book-details-page__status" },
            React.createElement("h1", null, "Fant ikke boken"),
            React.createElement("p", null,
                "Vi fant ingen bok med ISBN ",
                isbn,
                "."),
            React.createElement("a", { href: "/sok?query=" + encodeURIComponent(isbn) }, "S\u00F8k etter ISBN"));
    }
    return React.createElement("div", { className: "columns book-details-page" },
        React.createElement("div", { className: "main-content" },
            React.createElement("div", { className: "columns nowrap overhead" },
                React.createElement("h2", null, "Kj\u00F8p bok"),
                React.createElement("a", { href: "/sett_inn_annonse/?isbn=" + book.isbn, className: "button nogrow forward" },
                    "Selg boken i stedet",
                    React.createElement("img", { src: "/static/img/arrow_forward.svg", alt: "Naviger" }))),
            React.createElement(BookMetadata, { book: book, tags: tags }),
            React.createElement(ExternalPrices, { isbn: book.isbn, prices: externalPrices }),
            React.createElement("section", { id: "annonser" },
                React.createElement("h2", null, "Kj\u00F8p brukt p\u00E5 iBok"),
                React.createElement(BookPage, { isbn: String(book.isbn), user: user || null, userId: user === null || user === void 0 ? void 0 : user.id, coverUrl: book.imageUrl, useLegacyUserFallback: false })),
            React.createElement(BookNotification, { book: book, user: authError ? undefined : user, isAuthLoading: isAuthLoading })));
};
export default BookDetailsPage;
